import { Form, Input, Row } from "antd";
import { useEffect } from "react";
import { SystemDescriptions } from "src/common/descriptions";
import { QuotationPolicy } from "src/common/models/quotation";
import { getInputRequiredRule } from "src/common/util";
import { Col24 } from "src/components/Columns";
import { FormActionButtons } from "src/components/FormActionButtons";
import { v4 as uuidv4 } from 'uuid';

interface Props {
    onFinish: (policyItem: QuotationPolicy) => void
    onCancel: () => void
    initialValues?: QuotationPolicy
}

export const QuotationPolicyForm = (props: Props) => {

    const [form] = Form.useForm();

    const descriptions = SystemDescriptions.PAGES.QUOTATION.CREATE

    useEffect(() => {
        if (!props.initialValues) {
            return
        }

        form.setFieldsValue({
            name: props.initialValues.name,
            description: props.initialValues.description,
        })
    }, [props.initialValues, form])

    const onFinish = (formValues) => {
        const detailItem: QuotationPolicy = {
            name: formValues.name,
            description: formValues.description,
            ref: props.initialValues?.ref || uuidv4(),
        }
        form.resetFields();
        props.onFinish(detailItem)
    }

    const getButtonStatus = (): boolean => {
        return !form.isFieldsTouched(["name", "description"]) ||
            form.getFieldsError().filter(({ errors }) => errors.length)
                .length > 0
    }

    const renderButtons = () => (
        <FormActionButtons
            cancelText={descriptions.POLICY.FORM.CANCEL}
            actionText={descriptions.POLICY.FORM.ACCEPT}
            onCancel={() => {
                form.resetFields();
                props.onCancel()
            }}
            actionDisabled={getButtonStatus}
        />
    )

    const renderForm = () => (
        <Form
            form={form}
            size="small"
            layout="vertical"
            requiredMark={false}
            autoComplete={'none'}
            onFinish={onFinish}
        >
            <Row gutter={[16, 8]}>
                <Col24>
                    <Form.Item
                        label={descriptions.POLICY.FORM.NAME.LABEL}
                        name={"name"}
                        rules={[
                            getInputRequiredRule(descriptions.POLICY.FORM.NAME.LABEL),
                        ]}
                        validateTrigger="onBlur"
                    >
                        <Input
                            placeholder={descriptions.POLICY.FORM.NAME.PLACEHOLDER}
                        />
                    </Form.Item>
                </Col24>
                <Col24>
                    <Form.Item
                        label={descriptions.POLICY.FORM.DESCRIPTION.LABEL}
                        name={"description"}
                        rules={[
                            getInputRequiredRule(descriptions.POLICY.FORM.DESCRIPTION.LABEL),
                        ]}
                        validateTrigger="onBlur"
                    >
                        <Input
                            placeholder={descriptions.POLICY.FORM.DESCRIPTION.PLACEHOLDER}
                        />
                    </Form.Item>
                </Col24>
                {renderButtons()}
            </Row>
            {/* {
                reduxProps.error &&
                <Alert
                    message={"ERROR"}
                    showIcon
                    description={reduxProps.error?.detail.message ?? commonDescriptions.FORM.UNKNOWN_ERROR}
                    type="error"
                    style={{
                        marginBottom: 12,
                    }}
                />
            }
            {!props.readOnly && renderButtons()} */}
        </Form>
    )

    return (
        renderForm()
    )
}
